import { render, staticRenderFns } from "./AppointmentsStats.vue?vue&type=template&id=dda49e62&"
import script from "./AppointmentsStats.vue?vue&type=script&lang=js&"
export * from "./AppointmentsStats.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports